export { default } from './CPAlertDialog';
export * from './CPAlertDialog';
